// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { deleteComment, getAllComments, getComment, updateComment } from '../../helpers/backend_helper';
import { fetchCommentsFailure, fetchCommentsSuccess, updateCommentFailure, updateCommentSuccess } from './actions';
import { deleteCommentFailure, deleteCommentSuccess, fetchCommentFailure, fetchCommentSuccess } from '../actions';
import { DELETE_COMMENTS_REQUEST, FETCH_COMMENTS_REQUEST, FETCH_COMMENT_REQUEST, UPDATE_COMMENTS_REQUEST } from './actionTypes';
import { reduxSerializedError } from '../../utils/utils';

function* fetchCommentsSaga() {
  try {
    const response = yield call(getAllComments);

    // Store the mapping in localStorage
    yield put(fetchCommentsSuccess(response.data));
  } catch (error) {
    yield put(fetchCommentsFailure(reduxSerializedError(error)));
  }
}

function* fetchCommentSaga({ payload }) {
  try {
    const response = yield call(getComment, payload);
    yield put(fetchCommentSuccess(response));
  } catch (error) {
    yield put(fetchCommentFailure(reduxSerializedError(error)));
  }
}

function* deleteCommentsSaga({ payload }) {
  try {
    yield call(deleteComment, payload);
    yield put(deleteCommentSuccess(payload));
    yield call(fetchCommentsSaga);
  } catch (error) {
    yield put(deleteCommentFailure(reduxSerializedError(error)));
  }
}

function* updateCommentSaga({ payload }) {
  const { comment } = payload;
  try {
    yield call(updateComment, comment);
    yield put(updateCommentSuccess());
    yield call(fetchCommentsSaga); 
  } catch (error) {
    yield put(updateCommentFailure(reduxSerializedError(error)));
  }
}


export default function* rootSaga() {
  yield takeEvery(FETCH_COMMENTS_REQUEST, fetchCommentsSaga);
  yield takeEvery(FETCH_COMMENT_REQUEST, fetchCommentSaga);
  yield takeEvery(UPDATE_COMMENTS_REQUEST, updateCommentSaga);
  yield takeEvery(DELETE_COMMENTS_REQUEST, deleteCommentsSaga);
}
